import React from 'react';
import './index.scss';
export const PlayButton = props => {
	let size = props.size || 52;
	let iconSize = size * 0.6;
	let durationSize = size * 0.4;

	function handleClick() {
		props.onClick();
	}

	function add0(n) {
		if (n === 0) {
			return '00:';
		} else if (n < 10) {
			return '0' + n + ':';
		}
		return n + ':';
	}
	function calcTime(n) {
		let hours = Math.floor(n / 3600);
		if (hours) {
			hours = add0(hours);
		} else {
			hours = '';
		}
		let minutes = add0(Math.floor((n % 3600) / 60));
		let seconds = add0((n % 3600) % 60);
		return (hours + minutes + seconds).slice(0, -1);
	}
	return (
		<i
			className="common-play-button"
			style={{
				width: size + 'px',
				height: size + 'px'
			}}
			onClick={handleClick}>
			<span
				className="common-play-button-icon iconfont"
				style={{
					fontSize: iconSize,
					lineHeight: size + 'px'
				}}>
				&#xe66a;
			</span>
			{props.duration ? (
				<span
					className="duration"
					style={{
						fontSize: durationSize,
						lineHeight: durationSize + 'px',
						bottom: -durationSize + 'px'
					}}>
					{calcTime(props.duration)}
				</span>
			) : (
				''
			)}
		</i>
	);
};
